module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "el-button el-button--default",
    attrs: {
      "to": {
        name: _vm.routeName,
        params: {
          id: _vm.item.id
        }
      },
      "title": "Visualizar Dados"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e18ab6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/ShowButton.vue
// module id = 734
// module chunks = 2